import React, { useEffect } from 'react';
import moment from 'moment';
import { Collapse } from 'antd';
import FilterComponent from '../../../children/FilterComponent/FilterComponent';
import { FEEDBACK_360_TYPE_NON_COHORT } from '../../../../../../../config/questionTypeConstants';
import { BUTTON_NAME } from './constants';
import { deepCopy } from '../../../../../../utils/deepCopy';
import { getDataFromUrlToken } from '../../../../../../utils/urlDataStore';
import { URL_DATA } from '../../../../../../../config/urlDataConstants';
import { toast } from '../../../../../../utils/messageUtils';


const FilterSection = (props) => {
    useEffect(() => {
        if (!props.isVisualizationDataFectched) {
            callVisualizationApis()
        }
        if (!props.isSurveyListFetched) {
            const orgDetails = getDataFromUrlToken(URL_DATA.ORGANIZATION);
            props.fetchSurveysFromTheOrg({ projectTypes: FEEDBACK_360_TYPE_NON_COHORT, size: orgDetails.projectCount + 10 })

        }
    }, [])

    const [collapseActiveKey, setCollapseActiveKey] = React.useState(['0']);

    const header = (
        <div
            className='filter-header'
        >
            <span className='filter-header__subhead'>Filters</span>
            <span
                className='filter-header__sideopen'
            >
                {Array.isArray(collapseActiveKey) && collapseActiveKey.length > 0 ? 'Hide filters' : 'Show filters'}
            </span>
        </div >
    );

    const callVisualizationApis = () => {
        let payload = deepCopy({ ...props.benchmarkFiltersAnalysis })
        let date = payload.date
        if (date.customDateRange.length > 0) {
            date = { ...date, to: date.customDateRange[1], from: date.customDateRange[0] }
            delete date.preset
        }
        if (date.preset && date.preset != "") {
            delete date.from
            delete date.to
        }
        else {
            delete date.preset
        }
        delete date.customDateRange
        payload.date = date
        props.getCantAnswerResponses(payload)
        props.getDevAndStrengthVisualization(payload)
        props.getTopStrengthTopDev(payload)
        props.getTotalFeedbackProviders(payload)
        props.getRaterHeatmap(payload)

    }

    const handleApply = () => {
        if (props.benchmarkFiltersAnalysis && props.benchmarkFiltersAnalysis.surveys.length > 0) {
            setCollapseActiveKey([]);
        callVisualizationApis()
        }
        else {
            toast.info("Please select at least one survey to apply the filter.")
        }

    };


    const onCustomRangeChange = (range, date, dd) => {
        // When both dates are selected, set the custom range and clear any preset
        if (range && range[0] && range[1]) {
            props.handleChangeBenchmarkFilter({ changedItem: { date: { customDateRange: date, preset: "" } } })
            return;
        }

        // When cleared (RangePicker X button), reset the custom range and preset
        if (!range) {
            props.handleChangeBenchmarkFilter({ changedItem: { date: { customDateRange: [], preset: "" } } })
        }
    };

    const handleChangeFilterValues = (eventDetails) => {
        props.handleChangeBenchmarkFilter({ changedItem: eventDetails })


    }

    const getTotalProjectCount = () => {
        if (props.fetchSurveyLists.data && props.fetchSurveyLists.data.totalChildProjects) {
            if (props.fetchSurveyLists.data.totalNonCohortProjects) {
                return props.fetchSurveyLists.data.totalChildProjects + props.fetchSurveyLists.data.totalNonCohortProjects
            }
            return props.fetchSurveyLists.data.totalChildProjects
        }
        else return 0
    }



    return (
        <div className='filter-sectionWrapper'>
            <h2>Analysis</h2>
            <Collapse
                expandIconPosition="right"
                activeKey={collapseActiveKey}
                onChange={setCollapseActiveKey}
            >
                <Collapse.Panel header={header} key="0">
                    <FilterComponent
                        isError={props.fetchSurveyLists.error}
                        loader={props.fetchSurveyLists.isProcessing}
                        surveyList={props.fetchSurveyLists.data && props.fetchSurveyLists.data.data ? props.fetchSurveyLists.data.data : []}
                        totalCount={getTotalProjectCount()}
                        buttonName={BUTTON_NAME}
                        handleChangeFilterValues={handleChangeFilterValues}
                        dateFields={props.benchmarkFiltersAnalysis.date}
                        surveyField={props.benchmarkFiltersAnalysis.surveys}
                        raterGroups={props.benchmarkFiltersAnalysis.raterGroups}
                        onCustomRangeChange={onCustomRangeChange}
                        surveyNames={props.benchmarkFiltersAnalysis.surveyNames}
                        handleApply={handleApply}
                    />
                </Collapse.Panel>
            </Collapse>
        </div>
    );
};

export default FilterSection;

